module.exports = __webpack_public_path__ + "img/farmacon.9b81e50a.png";